"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { normalizeSingleFilterFormData } from "@/helpers/request-helpers";
import { ISku } from "@/interfaces/sku.interface";
import skuService from "@/services/sku.service";
import { IFilter } from "@/types/filter.types";
import {
  GetRequestProps,
  PaginatedResponse,
  RequestPagination,
  RequestsBaseReturn,
} from "@/types/requests.types";

export type UseGetSKUsReturn = RequestsBaseReturn<PaginatedResponse<ISku> | null>;

export interface UseGetSKUsProps extends RequestPagination, GetRequestProps {
  filters: IFilter<ISku>[];
}

type GetAllSwrParams = [string, number, number, IFilter<ISku>[]];

const useGetSKUs = ({
  pageNumber,
  pageSize,
  filters,
  isPaused = false,
}: UseGetSKUsProps): UseGetSKUsReturn => {
  const normalizedFilter = normalizeSingleFilterFormData(filters, "title");

  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<PaginatedResponse<ISku>, Error, GetAllSwrParams>(
    [SWR_KEYS.getProducts, pageNumber, pageSize, normalizedFilter],
    ([, _pageNumber, _pageSize, _filters]) =>
      skuService.filter(_filters, {
        pageNumber: _pageNumber,
        pageSize: _pageSize,
      }),
    {
      revalidateOnFocus: false,
      isPaused: () => isPaused,
    }
  );

  return { data, isLoading, error };
};

export default useGetSKUs;
